import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://api.irgoperations.com/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

// Remove Content-Type for FormData so the browser sets multipart/form-data
// with the correct boundary automatically — multer requires this.
// Also re-attach the Authorization header from localStorage on every request:
// api.defaults.headers.common is only set once at login time, so a hard
// refresh (fresh JS context) would otherwise drop it even though the token
// in localStorage is still valid.
api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  const token = localStorage.getItem("token");
  if (token && !config.headers["Authorization"]) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// On a genuinely expired/invalid token, clear it and send the user back to
// login instead of leaving parts of the UI silently broken.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadSession = Boolean(localStorage.getItem("token"));
      localStorage.removeItem("token");
      delete api.defaults.headers.common["Authorization"];
      // The chat app (/chat) shows its own sign-in screen, so it reloads in place and stays inside the
      // installed app. Not on a failed sign-in there (no session yet), which would wipe the error.
      if (/^\/chat(\/|$)/.test(window.location.pathname)) {
        if (hadSession) window.location.assign("/chat");
      } else if (window.location.pathname !== "/") {
        window.location.assign("/");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
